"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductId = void 0;
exports.getAllProductIds = getAllProductIds;
exports.getProductIdFrom = getProductIdFrom;
var ProductId;
(function (ProductId) {
    ProductId["Affirm"] = "affirm";
    ProductId["Equip"] = "equip";
    ProductId["InSync"] = "in-sync";
    ProductId["EMNavigator"] = "em-nav";
    ProductId["Inkling"] = "inkling";
    ProductId["Geodes"] = "geodes";
    ProductId["Digital"] = "digital";
    ProductId["Benchmark"] = "benchmark";
})(ProductId || (exports.ProductId = ProductId = {}));
function getAllProductIds() {
    return Object.values(ProductId);
}
function getProductIdFrom(value) {
    return getAllProductIds().find(function (id) { return id === value; });
}
